import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=94076eea&scoped=true&"
import script from "./UserItem.vue?vue&type=script&lang=ts&"
export * from "./UserItem.vue?vue&type=script&lang=ts&"
import style0 from "./UserItem.vue?vue&type=style&index=0&id=94076eea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94076eea",
  null
  
)

export default component.exports